<app-block-wrapper [_editable]="_editable()" [style]="resolvedStyle()">
  @for (blok of renderedBlocks(); track blok.uid) {
    <ndc-dynamic
      [ndcDynamicComponent]="$any(components[blok.component])"
      [ndcDynamicInputs]="blok.inputs"
    ></ndc-dynamic>
  }
</app-block-wrapper>
